const generateFileHeaders = ({
  contentType,
  fileName,
}: {
  contentType: string;
  fileName: string;
}): {
  'content-type': string;
  'content-disposition': string;
} => ({
  'content-type': contentType,
  'content-disposition': `attachment; filename=${fileName}; filename*=UTF-8''${fileName}`,
});

export default generateFileHeaders;
